import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { APP_ENVIRONMENT } from '@price-management-console/shared-ui';
import { Observable, throwError } from 'rxjs';
import { GridConfig, GridPreferences } from './preference-api.types';

@Injectable({
  providedIn: 'root',
})
export class UserPreferenceApiService {
  private readonly http = inject(HttpClient);
  private readonly environment = inject(APP_ENVIRONMENT);

  getServiceEndpoint(endpoint: string): string {
    if (!this.environment) {
      return endpoint;
    }
    return this.environment.USING_ANGULAR_PROXY
      ? `/preferences-api/${endpoint}`
      : `${this.environment.APIGEEX_HOST_URL}/${endpoint}`;
  }

  private getAuthHeaders(userId: string): HttpHeaders {
    return new HttpHeaders({
      'X-Authenticated-User-Id': userId,
    });
  }

  getPreferences(
    userId: string,
    applicationId: string,
    category: string,
    subCategory: string,
    preferenceCode: string
  ): Observable<GridPreferences> {
    if (!userId) {
      return throwError(
        () => new Error('userId is strictly required to fetch preferences.')
      );
    }

    const headers = this.getAuthHeaders(userId);

    const params = new HttpParams()
      .set('applicationId', applicationId)
      .set('category', category)
      .set('subCategory', subCategory)
      .set('preferenceCode', preferenceCode);

    return this.http.get<GridPreferences>(
      this.getServiceEndpoint(
        this.environment.APIGEE_USER_PREFERENCES_ENDPOINT
      ),
      {
        headers,
        params,
      }
    );
  }

  savePreferences(
    userId: string,
    configs: GridConfig[],
    applicationId: string,
    category: string,
    subCategory: string,
    preferenceCode: string
  ): Observable<string> {
    if (!userId) {
      return throwError(
        () => new Error('userId is strictly required to save preferences.')
      );
    }

    const headers = this.getAuthHeaders(userId);

    const body: GridPreferences = {
      applicationId,
      category,
      subCategory,
      preferenceCode,
      preferenceValue: {
        data: configs,
      },
    };

    return this.http.put(
      this.getServiceEndpoint(
        this.environment.APIGEE_USER_PREFERENCES_ENDPOINT
      ),
      body,
      {
        headers,
        responseType: 'text',
      }
    );
  }
}
